
import { Tooltip, Icon, Intent } from "construct-ui";
import ViewBase from "../view-base.view";
import FileUploadComponent from '../../components/file/file-upload.component';
import PopupManagementModel from '../../models/pop-up-management/pop-up-management.model';
import SingleSelectComponent from "../../components/single-select/single-select.component";
import MultiSelectComponent from "../../components/multi-select/multi-select.component";
import loginModel from "../../models/login.model";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import moment from 'moment';
import UserRoleModel from "../../models/user/user-role.model"
import codeMasterModel from "../../models/common/code-master.model";
import FileModel from "../../models/common/file.model";
import { formats as FORMATS, codeMasterType } from "../../config/constants";

export default function PopupAddView() {
  ViewBase.call(this);

  let onAddClose = (e) => { };
  let onSaveComplete = (e) => { };

  let _uploadingFiles = [];
  let divisions = [];
  let statuses = [];
  let userRoleOptionList = [];
  const inputDataModel = {
    title: "",
    contents: "",
    divisionList: [],
    status: {},
    userRoleList: [],
    periodFrom: "",
    periodTo: ""
  };
  let popupDetail = {}; // get from aqpi
  let userUploadedFiles = []; // get from aqpi

  const getUserRoleList = () => {
    UserRoleModel.getUserRoleList(
      (result) => {
        if (result) {
          userRoleOptionList = result
        }
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  const getStatuses = () => {
    codeMasterModel.getByCategoryV2({ category: 'PopupManagement' })
      .then((result) => {
        statuses = result

        inputDataModel.status = statuses.find(s => s.code === "Y")

      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const getDivisions = () => {
    const params = {
      countryCode: loginModel.credentials.country
    }
    codeMasterModel.searchByCategoryV2(codeMasterType.divisionGroup, params)
      .then(result => {
        divisions = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const onTitleChange = (e) => {
    inputDataModel.title = e.target.value;
  }

  const onContentChange = (e) => {
    inputDataModel.contents = e.target.value;
  }

  const getPopupById = (popupId) => {
    PopupManagementModel.getPopupNoticeDetail({ popupId })
      .then((result) => {
        inputDataModel.title = result.title;
        inputDataModel.contents = result.contents;
        inputDataModel.divisionList = divisions.filter((item) => result.divisionList.includes(item.code));
        inputDataModel.status = statuses.find((s) => result.useYN === s.code);
        inputDataModel.userRoleList = userRoleOptionList.filter((item) => result.userRoleList.includes(item.code));
        inputDataModel.periodFrom = moment(result.periodFrom).format(FORMATS.dateFormat);
        inputDataModel.periodTo = moment(result.periodTo).format(FORMATS.dateFormat);
        popupDetail = result;
        userUploadedFiles = result.fileList
      }).catch((error) => {
        this.handleError(error);
      })

  }

  const handleSave = (e) => {
    if (!this.validateForm(e, "#addPopupNotice")) {
      return false;
    } else {
      if (_uploadingFiles.length > 0) {
        let filesFormData = new FormData();
        _uploadingFiles.forEach(function (v, i) {
          filesFormData.append("file", v);
        });

        FileModel.uploadMultipleFiles(filesFormData, 'WebNoticePopupManagement')
          .then((result) => {
            savePopup(result, true);
          }).catch((error) => {
            this.handleError(error);
          })

      } else {
        savePopup([], false);
      }
    }
  }

  const savePopup = (fileResponses, isFilesIncluded) => {
    let _uplaodedFiles = [];

    if (isFilesIncluded) {
      fileResponses.forEach(function (file) {
        _uplaodedFiles.push(file[0].id);
      });
    }

    const paramsObj = structuredClone(inputDataModel)
    paramsObj.divisionList = paramsObj.divisionList.map((x) => x.code);
    paramsObj.userRoleList = paramsObj.userRoleList.map((x) => x.code);
    paramsObj.fileList = _uplaodedFiles;
    paramsObj.useYN = paramsObj.status.code;
    paramsObj.periodFrom = moment(paramsObj.periodFrom).format(FORMATS.apiDateFormat);
    paramsObj.periodTo = moment(paramsObj.periodTo).format(FORMATS.apiDateFormat);
    delete paramsObj.status;

    if (popupDetail && popupDetail.popupId) {
      if (userUploadedFiles && userUploadedFiles.length > 0) {
        const files = structuredClone(userUploadedFiles);
        _uplaodedFiles = _uplaodedFiles.concat(files.map(f => f.fileId))
        paramsObj.fileList = _uplaodedFiles;
      }
      PopupManagementModel.updatePopupNotice(paramsObj, popupDetail.popupId).then((result) => {
        onSaveComplete(result);
      }).catch((error) => {
        this.handleError(error);
      })
    } else {
      PopupManagementModel.savePopupNotice(paramsObj).then((result) => {
        onSaveComplete(result);
      }).catch((error) => {
        this.handleError(error);
      })
    }
  }

  const handleCancel = (e) => {
    onAddClose(e);
  }

  const handleDownload = (fileId, fileName) => {
    this.showLoading();
    FileModel.downloadByFileId(fileId, fileName)
      .then((result) => {
        // console.log(result)
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const loadPopupDetail = (popupId) => {
    this.showLoading();
    Promise.all([getDivisions(), getStatuses(), getUserRoleList()])
      .then(() => {
        if (popupId) {
          getPopupById(popupId)
        }
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  return {
    oninit: (vnode) => {
      loadPopupDetail(vnode.attrs.popupId)

      if (vnode.attrs.onAddClose) {
        onAddClose = vnode.attrs.onAddClose;
      }
      if (vnode.attrs.onSaveComplete) {
        onSaveComplete = vnode.attrs.onSaveComplete;
      }

    },
    view: (vnode) => {
      return [
        m('.card.mb-3',
          m('.card-body',
            m("form#addPopupNotice.row.g-4.needs-validation[novalidate]",
              {
                onsubmit: handleSave
              },
              m('.row.g-4',
                m('.col-md-12.position-relative',
                  m('label.form-label.mandatory[for="title"]', this.getText("LT00000037", "Title"),),
                  m('input#title[required][type=text][placeholder=' +
                    this.getText("LT00000037", "Title") + '][value="' + inputDataModel.title + '"] .form-control.form-control-bg', { maxlength: 100, onchange: onTitleChange }
                  ),
                  // m('.invalid-tooltip', this.getText("EM00000817", "Please select")),
                )
              ),
              m('.row.g-4.mt-2',
                m('.col-md-6.position-relative',
                  m('label.form-label.mandatory[for="division"]',
                    this.getText("LT00000233", "Division")
                  ),
                  m(MultiSelectComponent, {
                    id: "division",
                    items: divisions,
                    required: true,
                    selectedItems: inputDataModel.divisionList,
                    onSelect: (selectedItems) => {
                      inputDataModel.divisionList = selectedItems
                    }
                  }),
                  m('.invalid-tooltip', this.getText("LT00000201", "Please select")),
                ),
                m('.col-md-6.position-relative',
                  m('label.form-label.mandatory[for=userRole]', this.getText("LT00000060", "User Role")),
                  m(MultiSelectComponent, {
                    id: 'userRole',
                    required: true,
                    items: userRoleOptionList,
                    selectedItems: inputDataModel.userRoleList,
                    with: "100%",
                    onSelect: (s) => {
                      inputDataModel.userRoleList = s;
                    }
                  }),
                  m('.invalid-tooltip', this.getText("LT00000201", "Please select")),
                ),
              ),
              m('.row.g-4.mt-2',
                m('.col-md-6.position-relative',
                  m('label.form-label.mandatory[for="datePicker2"]', this.getText('LT00000150', 'Period')),
                  m(DatePickerComponent, {
                    id: 'datePicker2',
                    class: 'form-control',
                    placeholder: this.getText('LT00000895', 'Time Range'),
                    isRange: true,
                    required: true,
                    dateStart: inputDataModel.periodFrom,
                    dateEnd: inputDataModel.periodTo,
                    onselect: (event) => {
                      inputDataModel.periodFrom = event.detail.start;
                      inputDataModel.periodTo = event.detail.end;
                    }
                  }),
                  m('.invalid-tooltip', this.getText("LT00000201", "Please select")),
                ),
                m('.col-md-6.position-relative',
                  m('label.form-label.mandatory[for=status]', this.getText("LT00000015", "Status")),
                  m(SingleSelectComponent, {
                    id: 'status',
                    required: true,
                    items: statuses,
                    allowEmpty: true,
                    selectedItem: inputDataModel.status,
                    onSelect: (selectedItem) => {
                      inputDataModel.status = selectedItem
                    }
                  }),
                  m('.invalid-tooltip', this.getText("LT00000201", "Please select")),
                ),
              ),
              m('.row.g-4.mt-2',
                m('col-md-12.position-relative',
                  m('label.form-label.mandatory[for=txtContent]', this.getText("LT00000056", "Content")),
                  m('textarea#txtContent[required].form-control.form-control-bg',
                    {
                      onchange: onContentChange,
                      style: "width: 100%; height: 120px;",
                      placeholder: this.getText("LT00000056", "Content"),
                      // maxlength: 255 
                    },
                    inputDataModel.contents
                  ),
                  // m('.invalid-tooltip', this.getText("EM00000818", "Please select")),
                ),
              ),

              m('.row.g-4.mt-2',
                m('label.form-label', this.getText("LT00000047", "Attachments")),
                m(FileUploadComponent, {
                  acceptableFileTypes: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.jpg', '.jpeg', '.png'],
                  onGettingFiles: (e) => {
                    _uploadingFiles = e;
                  }
                })
              ),
              userUploadedFiles && userUploadedFiles.length > 0 && m('.row.g-4.mt-2',
                m('label.form-label', this.getText("LT00001190", "Uploaded Files")),
                m('.row.mt-3',
                  userUploadedFiles.map(file =>
                    [
                      m('.col-md-6.mb-2.d-flex.justify-content-between',
                        m('label.form-check-label', file.fileName),
                        m('div', [m(Tooltip, {
                          content: this.getText("LT00000457", "Delete File"),
                          position: "top",
                          hasArrow: true,
                          size: 'lg',
                          trigger: m(Icon, {
                            intent: Intent.NEGATIVE,
                            name: 'x-circle',
                            onclick: () => {
                              userUploadedFiles = userUploadedFiles.filter(u => u.fileId !== file.fileId);
                            },
                            size: 'xl'
                          })
                        }), m(Tooltip, {
                          content: this.getText("LT00000935", "Download File"),
                          position: "top",
                          hasArrow: true,
                          size: 'lg',
                          trigger: m(Icon, {
                            intent: Intent.PRIMARY,
                            name: 'arrow-down-circle',
                            style: { paddingLeft: '10px' },
                            onclick: () => {
                              handleDownload(file.fileId, file.fileName)
                            },
                            size: 'xl'
                          })
                        })])
                      )
                    ])
                )
              ),
              m('.row.g-4.mt-2',
                m('.col-md-6', [m('b', "Writer: "), m('span', popupDetail.createUserId || loginModel.credentials.username)]),
                m('.col-md-6', [m('b', "Date: "), m('span', moment(popupDetail.createDate || new Date()).format(FORMATS.dateFormat))]),
              ),
              m('.card-footer',
                m('.col-md-12.gap-2.mt-4.d-flex.justify-content-end',
                  m('button.btn.btn-primary[type="submit"].px-4.gap-3', this.getText('LT00000022', "Save")),
                  m(
                    "button.btn.btn-white[type='button']", { onclick: handleCancel },
                    this.getText("LT00000021", "Close")
                  )
                )
              )
            ),
          ),
        ),

        this.getBaseViews()
      ];
    }
  }
}
